var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-group"},[(_vm.heading)?_c('h3',{staticClass:"data-group__heading"},[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }